import { ProgressBarThreshold } from '@sorare/core/src/components/collections/ProgressBar';

import Collections from '@sorare/gameplay/src/components/collections/CollectionsPage';

import { NewUserDialog } from '@sorare/us-sports/src/components/collections/NewUserDialog';
import nbaCardsImg from '@sorare/us-sports/src/components/collections/NewUserDialog/assets/nbaCards.png';

import { ClubLayout } from '@sorare/manager/src/components/profile/ClubLayout';

const THRESHOLDS: ProgressBarThreshold[] = [
  { value: 0, bonus: '-' },
  { value: 35, bonus: '+1%' },
  { value: 100, bonus: '+2%' },
  { value: 200, bonus: '+3%' },
  { value: 400, bonus: '+4%' },
  { value: 500, bonus: '+5%' },
];

const CollectionsPage = () => {
  return (
    <ClubLayout>
      <NewUserDialog img={nbaCardsImg} />
      <Collections thresholds={THRESHOLDS} />
    </ClubLayout>
  );
};

export default CollectionsPage;
